<template>
    <div class="container p-0">
        <form @submit="onSubmit" id="GetCartInfo">
            <b-card bg-variant="light" class="w-100 d-block float-left mt-5" sub-title="تکمیل اطلاعات خرید">
                <div class="row">
                    <div class="col-12 text-center float-right">
                        <p>کاربر گرامی شما روش <strong>{{ bankPaymentTypes[cart.bankPaymentTypeId-1].name }}</strong> را انتخاب کرده اید، جهت تکمیل روند خرید اطلاعات زیر را تکمیل نمایید</p>
                    </div>
                    <div class="col-12 col-md-6 float-right">
                        <b-card class="mb-3" sub-title="اطلاعات خریدار را وارد نمایید">
                            <b-form-group :label="$t('param.cart.fullName')">
                                <b-form-input type="text"
                                              id="fullName"
                                              :data-label="$t('param.cart.fullName')"
                                              class="form-control"
                                              autocomplete="off"
                                              v-model="fullName"
                                              data-validations='["required"]'></b-form-input>
                            </b-form-group>
                            <b-form-group :label="$t('param.cart.mobile')">
                                <b-form-input type="number"
                                              id="mobile"
                                              :data-label="$t('param.cart.mobile')"
                                              class="form-control"
                                              autocomplete="off"
                                              v-model="mobile"
                                              data-validations='["required","mobile"]'></b-form-input>
                            </b-form-group>
                            <b-form-group :label="$t('param.cart.postalCode')">
                                <b-form-input type="number"
                                              id="postalCode"
                                              :data-label="$t('param.cart.postalCode')"
                                              class="form-control"
                                              autocomplete="off"
                                              v-model="postalCode"
                                              data-validations='["required","postalcode"]'></b-form-input>
                            </b-form-group>
                            <b-form-group :label="$t('param.cart.address')">
                                <b-form-input type="text"
                                              id="address"
                                              :data-label="$t('param.cart.address')"
                                              class="form-control"
                                              autocomplete="off"
                                              v-model="address"
                                              data-validations='["required"]'></b-form-input>
                            </b-form-group>
                        </b-card>
                    </div>
                    <div class="col-12 col-md-6 float-right">
                        <b-card v-if="cart.bankPaymentTypeId == 3" class="mb-3" sub-title="مبلغی که میخواهید با کارت بانکی پرداخت کنید را به ریال وارد نمایید">
                            <b-form-group :label="$t('param.cart.cashPrice')">
                                <b-form-input type="text"
                                              id="cashPrice"
                                              :data-label="$t('param.cart.cashPrice')"
                                              class="form-control"
                                              autocomplete="off"
                                              v-model="cashPrice"
                                              data-validations='["required"]'></b-form-input>
                            </b-form-group>
                        </b-card>
                        <b-card v-if="cart.bankPaymentTypeId == 1 || cart.bankPaymentTypeId == 3" class="mb-3" sub-title="تعداد اقساط مورد نظر خود را وارد نمایید">

                            <div class="alert alert-info">
                                توجه نمایید تعداد اقساط نمیتواند بیشتر از {{ cart.items[0].product.splitCount }} باشد.
                            </div>
                            <b-form-group :label="$t('param.cart.splitCount')">
                                <b-form-input type="number"
                                              id="splitCount"
                                              :data-label="$t('param.cart.splitCount')"
                                              class="form-control"
                                              autocomplete="off"
                                              v-model="splitCount"
                                              data-validations='["required"]'></b-form-input>
                            </b-form-group>
                        </b-card>
                        <div class="w-100">
                            <p class="alert alert-warning flo mt-2 errors" v-if="warnings.length">
                                <label></label>
                                <ul>
                                    <li v-for="warning in warnings">
                                        {{ $t(warning.type,{label:warning.label}) }}
                                    </li>
                                </ul>
                            </p>
                            <p class="alert alert-danger mt-2 errors" v-if="errors.length">
                                <label></label>
                                <ul>
                                    <li v-for="error in errors">
                                        {{ $t(error.type) }}
                                    </li>
                                </ul>
                            </p>
                            <div v-if="!loading" class="w-100">
                                <div class="col-5 pr-0 pl-1 float-right">
                                    <button class="btn btn-outline-dark btn-block mt-2" type="button" @click="onPrev">
                                        <span v-if="!loading">تغییر روش پرداخت</span>
                                    </button>
                                </div>
                                <div class="col-7 pr-1 pl-0 float-right">
                                    <button class="btn btn-block  btn-dark mt-2" type="submit" v-bind:disabled="loading">
                                        <span v-if="!loading">تکمیل خرید</span>
                                        <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                                    </button>
                                </div>
                            </div>
                            <div v-else class="text-center">
                                <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
                                <p class="pt-2">
                                    <span>در حال ایجاد فاکتور، لطفا کمی صبر کنید ...</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </form>
    </div>
</template>
<script>
    import store from "@/store";
    import utility from '@/plugins/utility';

    export default {
        data()
        {
            return {
                loading: false,
                screenWidth: null,
                warnings: [],
                errors: [],
                fullName: '',
                mobile: '',
                address: '',
                splitCount: '',
                cashPrice: '',
                postalCode: '',
                bankPaymentTypes:
                    [{ bankPaymentTypeId: 1, name: 'پرداخت با استفاده از نیکارت' },
                    { bankPaymentTypeId: 2, name: 'پرداخت با استفاده از کارت بانکی' },
                    { bankPaymentTypeId: 3, name: 'پرداخت با استفاده از نیکارت و کارت بانکی' }],
                cart: store.cart
            };
        },

        beforeMount()
        {
            if (store.customer)
            {
                this.fullName = store.customer.fullName;
                this.mobile = store.customer.mobile;
                this.address = store.customer.address;
            }

            this.screenWidth = window.outerWidth;
        },

        methods: {

            onSubmit(evt)
            {
                var self = this;
                evt.preventDefault()
                this.warnings = new utility.form('#GetCartInfo').errors();
                this.errors = [];

                if (this.cart.bankPaymentTypeId == 3)
                {
                    if (Number(this.cashPrice) > this.cart.totalPrice)
                    {
                        this.warnings.push({
                            type: "validation.invalid",
                            label: "مبلغ کارت بانکی",
                        })
                    }
                }

                if (this.cart.bankPaymentTypeId == 1 || this.cart.bankPaymentTypeId == 3)
                {
                    if (Number(this.splitCount) > this.cart.items[0].product.splitCount || Number(this.splitCount) == 0)
                    {
                        this.warnings.push({
                            type: "validation.invalid",
                            label: "تعداد اقساط",
                        })
                    }
                }

                if (this.warnings.length == 0)
                {
                    var data = {
                        BankPaymentTypeID: this.cart.bankPaymentTypeId,
                        ShopID: this.cart.items[0].product.shopId,
                        SplitCount: this.splitCount,
                        CashPrice: this.cashPrice,
                        FullName: this.fullName,
                        Mobile: this.mobile,
                        Address: this.address,
                        PostalCode: this.postalCode,
                        ShopInvoiceProducts: []
                    };

                    this.loading = true;
                    for (var i = 0; i < store.cart.items.length; i++)
                    {
                        data.ShopInvoiceProducts.push({
                            ProductID: store.cart.items[i].product.productId,
                            Count: store.cart.items[i].count,
                        })
                    }

                    axios({
                        method: 'post',
                        url: '/api/app/SaveInvoice',
                        data: data
                    })
                        .then(response =>
                        {
                            if (response.data.success)
                            {
                                window.location.href = response.data.meta.url;
                            }
                            else
                            {
                                this.loading = false;
                                this.errors = [{ type: 'errors.payment' }];
                            }
                        })
                        .catch(error =>
                        {
                            this.loading = false;
                            this.errors = [{ type: 'errors.payment' }];
                        });
                }
            },


            onPrev()
            {
                this.$emit('step', 1)
            }

        }
    };
</script>
